import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[720px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">{contactData.title}</h2>
          <p className="mt-2 text-lg text-foreground-600 font-medium">{contactData.subtitle}</p>
          <p className="mt-3 text-sm text-foreground-700 leading-relaxed">{contactData.description}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-10 max-w-[800px] mx-auto">
          {contactData.channels.map((ch) => (
            <div
              key={ch.label}
              className="flex flex-col items-center text-center p-6 bg-background-50 rounded-lg border border-background-200 cursor-pointer hover:border-primary-200 hover:bg-primary-50/30 transition-all"
            >
              <span className="w-12 h-12 flex items-center justify-center text-2xl text-primary-500 bg-primary-100 rounded-full mb-4">
                <i className={ch.icon}></i>
              </span>
              <h3 className="text-base font-semibold text-foreground-900">{ch.label}</h3>
              <p className="mt-1 text-xs text-foreground-500">{ch.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}